import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import { datepicker } from '../vendor/datepickerVendor';

const datePicker = {

    init() {
        this.$trigger = $('[data-js-datepicker="trigger"]');
        this.$target = $('[data-js-datepicker="target"]');


        this.picker = this.$trigger.datepicker({
            format: 'dd/mm/yyyy'
        })

        this.eventHandlers();
    },

    eventHandlers() {
        this.picker.on('pick.datepicker',this.onDatePick.bind(this));
    },

    onDatePick(e) {
        e.preventDefault();
        const date = e.date;

        this.$trigger[0].innerHTML = moment(date).format('D MMM YYYY');

        this.postDate(moment(date).toISOString(true))

    },

    postDate(date) {

        const url = this.$trigger.data('ajax');

        axios.patch(url,{
            trained_at: date
        }).then((response)=>{
            console.log(response);
        });

    }
    

}

$(document).ready(()=>{
    datePicker.init();
})